import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    gap: 40px;
    padding-bottom: 20px;

    @media (max-width: 1380px) {
        width: 100%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    @media (max-width: 917px) {
        gap: 20px;
        padding-bottom: 15px;
    }
`;
